module.exports = __webpack_public_path__ + "img/icon-fb.b8638670.svg";